// extracted by mini-css-extract-plugin
module.exports = {"Arrows":"Arrows-module--Arrows--121q2","arrowPrev":"Arrows-module--arrowPrev--3OiJe","arrowNext":"Arrows-module--arrowNext--3zby-"};